module.exports = __webpack_public_path__ + "static/img/bg_1.3e1f58c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs/bg_1.jpg
// module id = l8Dl
// module chunks = 0